/**
 * Modal for reassigning a medical PA order to a different provider.
 * @module reAssignModal
 */

import { Modal } from "risa-oasis-ui_v2";
import {
  REASSIGN_MODAL_CANCEL_BUTTON_TEXT,
  REASSIGN_MODAL_SAVE_BUTTON_TEXT,
  REASSIGN_MODAL_TITLE,
} from "../../../constants/stringLiterals";
import { ReAssignModalBody } from "./components/ReAssignModalBody";
import { useReAssignModal } from "./hooks/useReAssignModal";
import { ReAssignModalProps } from "./types";

/**
 * Modal that allows reassigning a medical PA order to a different provider.
 * Uses bulk Postgres update when linked siblings exist; otherwise a single-order
 * update via {@link useUpdateOrderDetails}.
 *
 * @param props - Order id, current assignee, and optional completion callback
 * @returns Reassign modal element
 */
const ReAssignModal = (props: ReAssignModalProps) => {
  const {
    providerId,
    setProviderId,
    options,
    loading,
    assignOrderToProvider,
    abortAll,
    dialogId,
  } = useReAssignModal(props);

  return (
    <Modal
      dialogId={dialogId}
      onSave={assignOrderToProvider}
      title={REASSIGN_MODAL_TITLE}
      saveButtonText={REASSIGN_MODAL_SAVE_BUTTON_TEXT}
      cancelText={REASSIGN_MODAL_CANCEL_BUTTON_TEXT}
      disableSave={providerId === "" || loading}
      onClose={abortAll}
      onCancel={abortAll}
    >
      <ReAssignModalBody
        assignedTo={props.assignedTo}
        assignedToId={props.assignedToId}
        providerId={providerId}
        options={options}
        onProviderChange={setProviderId}
      />
    </Modal>
  );
};

export default ReAssignModal;
